import { ChangeEvent, useState } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import { useGetInventoryAllHistoryQuery } from "hooks/InventoryManagement/useGetInventoryAllHistoryQuery";
import { Modal, Radio, Table, TablePaginationConfig } from "antd";
import Loader from "Components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Button from "Components/Button";
import { PlusIcon } from "Layout/icons";
import KoboConverter from "Components/KoboConverter";
import { useGetBranchesQuery } from "hooks/BranchManagement/useGetBranchesQuery";
import { useDebounce } from "hooks/useDebounce";
import { cn } from "utils";

const Inventory = () => {
  const [branchSearch] = useState("");

  const debouncedSearch = useDebounce(branchSearch);
  const { data, isPending } = useGetInventoryAllHistoryQuery();
  const { data: branches, isPending: isLoadingBranches } = useGetBranchesQuery({
    search: debouncedSearch,
  });

  const [branchModal, setBranchModal] = useState(false);

  const [pagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: data?.data?.meta?.limit,
  });

  const [selectedBranch, setSelectedBranch] = useState<any>({});

  const getBranchById = (id: string) => {
    return branches?.data?.docs.find((branch) => branch.id === id);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setSelectedBranch((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const handleTableChange = (newPagination: TablePaginationConfig) => {
  //   setPagination((prev) => ({
  //     ...prev,
  //     current: newPagination.current ?? 1,
  //     pageSize: newPagination.pageSize ?? 10,
  //   }));
  // };

  const navigate = useNavigate();

  const columns = [
    {
      title: "Purpose",
      dataIndex: "purpose",
      key: "purpose",
      render: (text: string, record: any) => (
        <span>{record?.purpose ?? "Unknown Purpose"}</span>
      ),
    },
    {
      title: "Invoice no.",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (totalAmount: number) => (
        <span>
          <KoboConverter amount={totalAmount} />
        </span>
      ),
    },
    {
      title: "Total Item(s)",
      dataIndex: "totalItem",
      key: "totalItem",
      render: (totalItem: string) => (
        <span className="text-[13px]">{totalItem}</span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Branch",
      dataIndex: "branchId",
      key: "branchId",
      render: (branchId: any) => branchId?.name,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (updatedAt: string) => new Date(updatedAt).toLocaleString(),
    },
  ];

  return (
    <DashboardLayout
      title="Inventory"
      back={false}
      right={
        <Link to="/product-management/inventory/add">
          <Button
            label={
              <div className="flex items-center gap-2">
                <PlusIcon />
                Add Inventory
              </div>
            }
          />
        </Link>
      }
      //   right={<SearchBox search={search} setSearch={setSearch} />}
    >
      {/* <div className="pl-[20px] pr-[40px]"> */}
      <div className="flex justify-end pr-[40px]">
        <select name="branch" id="" onChange={handleInputChange}>
          {branches?.data?.docs?.map(({ id, name }: any) => (
            <option key={id}>{name}</option>
          ))}
        </select>
        <button
          onClick={() => {
            setBranchModal(true);
          }}
        >
          {selectedBranch?.name ? selectedBranch?.name : "Select Branch"}
        </button>
        <Modal
          title="Select Branch"
          open={branchModal}
          onCancel={() => setBranchModal(false)}
          footer={null}
        >
          {/* <div className="w-full grid justify-between grid-cols-[1fr_auto] gap-x-2">
            <SearchBox
              value={branchSearch}
              onChange={setBranchSearch}
              placeholder="Search Branch"
              className="rounded-xl bg-[#F3F3F3]"
            />
            <Button
              label="Add New Customer"
              className="px-3 py-4 rounded-xl max-h-[44px]"
            />
          </div> */}

          {isLoadingBranches && <Loader />}
          {branches?.data?.docs && (
            <Radio.Group
              value={selectedBranch?.id}
              onChange={(e) => setSelectedBranch(getBranchById(e.target.value))}
              className="w-full"
              name="branch"
            >
              <div className="max-h-[70vh] overflow-y-auto py-4 w-full">
                {/* <div
                  className={cn(
                    "flex gap-1 items-center relative max-h-[44px] min-h-[44px] bg-white w-full border duration-300 border-[#d3d3d3] focus:border-primary-light rounded-md"
                  )}
                >
                  <div className="flex justify-center items-center px-3">
                    <SearchIcon className="relative top-0 left-0" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search Branch"
                    value={branchSearch}
                    onChange={(e) => setBranchSearch(e.target.value)}
                    className="w-full h-full bg-transparent outline-none border-none flex-1 bg-black"
                  />
                </div> */}

                {branches.data.docs.map((branch) => (
                  <Radio
                    key={branch.id}
                    value={branch.id}
                    className={cn(
                      "flex items-center space-x-2 border-b border-border px-4 py-3",
                      branch.id === selectedBranch?.id ? "bg-primary-light" : ""
                    )}
                  >
                    <div className="flex items-center space-x-3">
                      <div className="space-y-3">
                        <h3 className="text-sm font-medium">{branch.name}</h3>
                        <p className="text-sm text-gray-500 font-normal">
                          {branch.address}, {branch.state}
                        </p>
                        <p className="text-sm text-gray-500 font-normal">
                          {branch.phoneNumber}
                        </p>
                      </div>
                    </div>
                  </Radio>
                ))}
              </div>
            </Radio.Group>
          )}
        </Modal>
      </div>
      {isPending && <Loader />}
      {!isPending && data && (
        <Table
          rowKey="id"
          columns={columns}
          pagination={pagination}
          // rowSelection={rowSelection}
          onRow={(record: any) => ({
            onClick: () =>
              navigate(`/product-management/inventory/${record?.id}`),
          })}
          scroll={{ y: "70vh" }}
          dataSource={data?.data?.docs}
          className="pl-[19px] pr-[40px] manrope mt-[20px]"
        />
      )}
    </DashboardLayout>
  );
};

export default Inventory;
